import { motion } from "framer-motion";
import { Facebook, Instagram } from "lucide-react";
import { SOCIAL } from "../data";

export const SocialSection = () => {
  return (
    <section
      id="redes"
      data-testid="social-section"
      className="relative py-20 md:py-28 bg-[#FBF5EA] overflow-hidden"
    >
      <div className="absolute inset-0 bg-grain" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-brand-gold uppercase tracking-[0.35em] text-xs mb-4"
        >
          Síguenos
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-burgundy leading-tight"
        >
          El antojo continúa en nuestras redes
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-5 text-brand-burgundy/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed"
        >
          Fotos, novedades y todo lo que se cocina en La Herencia Castañón.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-5"
        >
          <a
            href={SOCIAL.facebook}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-facebook"
            aria-label="Facebook de La Herencia Castañón"
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-brand-burgundy text-brand-cream font-bold uppercase tracking-widest text-sm px-9 py-5 rounded-2xl hover:bg-brand-red transition-colors duration-300 shadow-lg shadow-brand-burgundy/15"
          >
            <Facebook className="w-6 h-6 text-brand-gold group-hover:scale-110 transition-transform" />
            Facebook
          </a>
          <a
            href={SOCIAL.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-instagram"
            aria-label="Instagram de La Herencia Castañón"
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-base font-bold uppercase tracking-widest text-sm px-9 py-5 rounded-2xl hover:bg-brand-goldlight transition-colors duration-300 shadow-lg shadow-brand-gold/20"
          >
            <Instagram className="w-6 h-6 group-hover:scale-110 transition-transform" />
            Instagram
          </a>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: 0.45 }}
          className="mt-8 font-display italic text-brand-burgundy/60 text-lg"
        >
          @barbacoa.hc
        </motion.p>
      </div>
    </section>
  );
};
